import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export function redirectTo(path) {
  history.push(path);
}